// const HTproblemStatements = [
//   {
//     statementId: "HT1",
//     problemStatement:
//       "In today's fast-paced world, managing health appointments efficiently is crucial. Imagine a platform that allows patients to seamlessly connect with doctors, book appointments, and keep track of their health consultations—all in one place.",
//     exampleFeatures: [
//       "Doctor Search: Patients should be able to search for doctors by specialty (e.g., cardiology, dermatology), location, and availability.",
//       "Appointment Booking: Once a suitable doctor is found, the patient should be able to book an appointment based on the doctor’s available slots.",
//       "Appointment Management: Both doctors and patients should be able to view and manage upcoming and past appointments, including cancellations or rescheduling.",
//       "User Profiles: Patients can create and manage profiles with their basic health information, while doctors can have profiles displaying their qualifications, specialties, and schedules.",
//       "Notifications: The system should notify patients and doctors about upcoming appointments via email.",
//       "Admin Panel: An admin panel should allow platform administrators to manage users (both doctors and patients), monitor system usage, and ensure smooth operation.",
//     ],
//     extracontent: "",
//   },
//   {
//     statementId: "HT2",
//     problemStatement:
//       "Maintaining a healthy diet is key to overall well-being, but creating personalized meal plans can be challenging. Your task is to develop a Nutrition and Diet Planning App that helps users create tailored meal plans based on their dietary restrictions, preferences, and health goals.",
//     exampleFeatures: [
//       "Personalized Meal Plans: Users can input their dietary restrictions (e.g., vegan, gluten-free), food preferences, and health goals (e.g., weight loss, muscle gain) to receive customized meal plans.",
//       "Recipe Suggestions: The app should provide daily recipe suggestions based on the user’s meal plan and dietary needs.",
//       "Caloric Tracking: Users can track their daily caloric intake and monitor macronutrient breakdowns (carbs, proteins, fats).",
//       "User Profiles: Each user can create a profile to store their health data, preferences, and progress.",
//     ],
//     extracontent: "",
//   },
//   {
//     statementId: "HT3",
//     problemStatement:
//       "Building and maintaining healthy habits can significantly improve overall well-being. Your challenge is to design an app that helps users develop and sustain healthy habits, such as regular exercise, proper hydration, and consistent sleep patterns.",
//     exampleFeatures: [
//       "Habit Tracking: Users can set and track daily or weekly goals for healthy habits like exercise, hydration, and sleep.",
//       "Reminders & Notifications: The app should send reminders to help users stay consistent with their habits.",
//       "Progress Monitoring: Users can view their progress over time with habit completion rates and streaks.",
//       "User Profiles: Each user can create a profile to set goals, monitor achievements, and track habit history.",
//     ],
//     extracontent: "",
//   },
//   {
//     statementId: "HT4",
//     problemStatement:
//       "Managing healthcare can be complex, especially when patients have to handle multiple tasks such as booking appointments, tracking vital signs, and following medical advice. Your challenge is to develop an AI Healthcare Assistant that simplifies this process by providing personalized healthcare management for patients.",
//     exampleFeatures: [
//       "Personalized Advice: The AI should offer tailored health advice based on individual patient needs and medical history.",
//       "Appointment Scheduling: The assistant should help patients schedule and manage doctor appointments.",
//       "Vitals Monitoring: The system should track and monitor key vitals, such as heart rate, blood pressure, and more.",
//       "Learning from Interactions: The AI should learn from patient interactions over time to provide increasingly personalized and accurate support.",
//     ],
//     extracontent: "",
//   },
//   {
//     statementId: "HT5",
//     problemStatement:
//       "In the rapidly evolving healthcare landscape, securing and managing patient data is critical. Your challenge is to develop a Blockchain-based Healthcare Data Management System that ensures secure and patient-centric control of health records, allowing patients to manage who can access their data.",
//     exampleFeatures: [
//       "Blockchain Security: Use blockchain to securely store patient health records, ensuring that data cannot be tampered with.",
//       "Patient-Controlled Access: Patients should have the ability to grant or revoke access to their health records for specific healthcare providers.",
//       "Basic Interoperability: Allow healthcare providers to access patient data from the system using permissions, ensuring basic compatibility with existing health record formats.",
//       "Audit Logs: Track all access to patient data in a transparent, unchangeable log to ensure data access accountability.",
//     ],
//     extracontent: "",
//   },
// ];

// export default HTproblemStatements;
const HTproblemStatements = [
  {
    statementId: "HT1",
    problemStatement:
      "In today’s fast-paced world, medical consultations are often rushed, leading patients to forget important details or communicate ineffectively. This results in incomplete diagnoses and reduced quality of care. Imagine a platform that helps patients prepare beforehand by organizing their symptoms, medical history, and concerns into a clear format, making consultations more efficient and meaningful.",
    exampleFeatures: [
      "Symptom Form Builder: Patients can input symptoms, medical history, medications, and concerns through guided forms.",
      "Structured Summary Output: The system generates a clean, well-organized report that can be shared with the doctor before or during the visit.",
      "Visit Checklist: Provides a personalized checklist of important topics and questions the patient should discuss during the consultation.",
      "Export/Share Feature: Patients can download or directly send their consultation summary to the doctor via email or app integration."
    ],
    extracontent:
      "This platform focuses on before the consultation, not after."
  },
  {
    statementId: "HT2",
    problemStatement:
      "In today’s healthcare journey, patients often struggle to follow treatment plans consistently due to a lack of structure and guidance. This leads to missed medications and reduced effectiveness. Imagine a platform that simplifies treatment plans into clear, daily routines, helping patients stay consistent and on track with recovery.",
    exampleFeatures: [
      "Treatment Plan Input: Patients can enter prescriptions, diet instructions, exercise routines, and other medical advice provided by their doctor.",
      "Daily Routine Generator: Automatically converts the treatment plan into clear, day-wise tasks (medication timings, meals, workouts, etc.).",
      "Task Tracker Dashboard: A centralized dashboard where users can view, manage, and track their daily health tasks.",
      "Completion Tracking & Progress View: Visual insights into adherence, streaks, and overall progress to motivate consistency."
    ],
    extracontent:
      "This platform focuses on the execution of treatment, not just reminders."
  },
  {
    statementId: "HT3",
    problemStatement:
      "In today’s healthcare journey, patients often receive multiple medical documents but struggle to manage them effectively. This leads to confusion, missed follow-ups, and poor continuity of care. Imagine a platform that organizes these documents into a clear, step-by-step workflow, helping patients know what to do next at every stage of treatment.",
    exampleFeatures: [
      "Document Upload: Patients can upload various medical documents such as reports, prescriptions, and invoices in one place.",
      "Stage Tagging: Documents can be categorized by stages like diagnosis, treatment, and follow-up for better organization.",
      "Workflow Timeline: A visual timeline that shows the patient’s healthcare journey and progress across different stages.",
      "Pending Actions Tracker: Highlights pending tasks such as tests, medications, or doctor visits derived from documents."
    ],
    extracontent:
      "It combines document + action workflow."
  },
  {
    statementId: "HT4",
    problemStatement:
      "In today’s healthcare experience, patients often leave consultations confused due to complex medical terminology. This leads to misunderstandings about their condition and treatment. Imagine a platform that simplifies doctor-patient conversations into clear, easy explanations, helping patients fully understand their care and next steps.",
    exampleFeatures: [
      "Conversation Input: Patients can input doctor notes, prescriptions, or even transcribed consultation conversations.",
      "AI Simplifier: Converts complex medical jargon into easy-to-understand, everyday language.",
      "Context Awareness: Ensures that simplification retains the correct medical meaning and intent.",
      "Highlight Important Actions: Clearly identifies key instructions such as medications, tests, and lifestyle changes.",
      "Multi-language Output: Provides simplified explanations in multiple languages for better accessibility."
    ],
    extracontent:
      "This focuses on conversation clarity, not just reports."
  }
];

export default HTproblemStatements;